import script from "./LocaleSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./LocaleSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./LocaleSwitcher.vue?vue&type=style&index=0&id=43d4ded5&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43d4ded5"]])

export default __exports__